// extracted by mini-css-extract-plugin
module.exports = {"ck-editor-block":"FeatureBlock_ck-editor-block__avmRT"};